import type { ThemeUIStyleObject } from 'theme-ui';

export const containerStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  gap: '0.5rem',
  marginLeft: ['0.5rem', '2rem'], // mobile, desktop
  marginRight: ['0.5rem', '2rem'], // mobile, desktop
  marginTop: '0.5rem',
  marginBottom: '0.5rem',
  padding: ['0.5rem', '0.75rem'], // mobile, desktop
  bg: 'neutral/000', // Light background to distinguish from main items
  borderRadius: '0.5rem',
  border: '1px solid',
  borderColor: 'neutral/200',
};

export const headerStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  gap: '0.5rem',
};

export const formStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  gap: '0.5rem',
};

export const commentsListStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  gap: ['1rem', '2rem'], // mobile, desktop - tighter on mobile
  padding: ['0.75rem 0', '1rem 0'], // mobile, desktop
};

export const commentItemStyles: ThemeUIStyleObject = {
  flexDirection: 'column',
  gap: ['0.375rem', '0.5rem'], // mobile, desktop
};

export const commentHeaderStyles: ThemeUIStyleObject = {
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const userInfoStyles: ThemeUIStyleObject = {
  flexDirection: 'row',
  gap: ['0.25rem', '0.5rem'], // mobile, desktop
  flex: 1,
  marginLeft: ['0.5rem', '1rem'], // mobile, desktop
  alignItems: 'center',
  flexWrap: 'wrap',
};

export const actionsStyles: ThemeUIStyleObject = {
  gap: ['0.75rem', '1.5rem'], // mobile, desktop
  alignItems: 'center',
};
